module.exports = __webpack_public_path__ + "static/media/rsz_scooter.27c3334f.png";